"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useChatContext } from "./chat-provider";
import { MessageCircle, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslations } from "next-intl";
export function ChatWidgetButton() {
  const $ = _c(34);
  const t = useTranslations("chat.widget");
  const {
    isOpen,
    setIsOpen,
    unreadCount
  } = useChatContext();
  const [showTooltip, setShowTooltip] = useState(false);
  let t0;
  let t1;
  if ($[0] !== isOpen) {
    t0 = () => {
      if (isOpen) {
        setShowTooltip(false);
        return;
      }
      const timer = setTimeout(() => setShowTooltip(true), 3000);
      return () => clearTimeout(timer);
    };
    t1 = [isOpen];
    $[0] = isOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== showTooltip) {
    t2 = () => {
      if (!showTooltip) {
        return;
      }
      const timer_0 = setTimeout(() => setShowTooltip(false), 8000);
      return () => clearTimeout(timer_0);
    };
    t3 = [showTooltip];
    $[3] = showTooltip;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  const t4 = isOpen && "hidden sm:flex";
  let t5;
  if ($[6] !== t4) {
    t5 = cn("fixed bottom-6 right-6 z-50 flex items-end gap-3", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isOpen || $[9] !== setIsOpen || $[10] !== showTooltip || $[11] !== t) {
    t6 = showTooltip && !isOpen && <div className="animate-in fade-in slide-in-from-right-2 cursor-pointer rounded-lg bg-card px-4 py-2.5 text-sm shadow-lg border border-border" onClick={() => {
      setIsOpen(true);
      setShowTooltip(false);
    }}><p className="font-medium text-foreground">{t("tooltipOnline")}</p><p className="text-xs text-muted-foreground">{t("tooltipMessage")}</p></div>;
    $[8] = isOpen;
    $[9] = setIsOpen;
    $[10] = showTooltip;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isOpen || $[14] !== setIsOpen) {
    t7 = () => setIsOpen(!isOpen);
    $[13] = isOpen;
    $[14] = setIsOpen;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("relative flex h-14 w-14 items-center justify-center rounded-full shadow-lg transition-all hover:scale-105", "bg-accent text-accent-foreground");
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isOpen || $[18] !== t) {
    t9 = isOpen ? t("closeChat") : t("openChat");
    $[17] = isOpen;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== isOpen) {
    t10 = isOpen ? <X className="h-6 w-6" /> : <><MessageCircle className="h-6 w-6" /><span className="absolute right-0 top-0 h-3 w-3 rounded-full border-2 border-accent bg-green-400" /></>;
    $[20] = isOpen;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== isOpen || $[23] !== unreadCount) {
    t11 = !isOpen && unreadCount > 0 && <span className="absolute -left-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white">{unreadCount > 9 ? "9+" : unreadCount}</span>;
    $[22] = isOpen;
    $[23] = unreadCount;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t7 || $[28] !== t9) {
    t12 = <button onClick={t7} className={t8} aria-label={t9}>{t10}{t11}</button>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t7;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12 || $[31] !== t5 || $[32] !== t6) {
    t13 = <div className={t5}>{t6}{t12}</div>;
    $[30] = t12;
    $[31] = t5;
    $[32] = t6;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
}